import { css } from '@emotion/core';
import {
  minimumWidth,
  pxToRem,
  SkeletonLoaderCircle,
  SkeletonLoaderButton,
  styled,
  SkeletonLoaderText,
} from '@feast-it/ui/light';

const HEADER_HEIGHT = 60;

export const LayoutSkeletonWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: ${pxToRem(HEADER_HEIGHT)};
    border-bottom: ${pxToRem(1)} solid ${theme.colors.lightGrey};
    padding: ${theme.spacing[4]};

    ${minimumWidth(theme.breakpoints.small)} {
      padding: ${theme.spacing[8]};
    }

    ${minimumWidth(theme.breakpoints.medium)} {
      padding: ${theme.spacing[10]};
    }
  `
);

export const LayoutSkeletonCircle = styled(SkeletonLoaderCircle)(
  ({ theme }) => css`
    ${minimumWidth(theme.breakpoints.medium)} {
      display: none;
    }
  `
);

export const ButtonContainer = styled.div(
  ({ theme }) => css`
    display: none;

    ${minimumWidth(theme.breakpoints.medium)} {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  `
);

export const StyledSkeletonText = styled(SkeletonLoaderText)(
  ({ theme }) => css`
    width: ${pxToRem(70)};
    margin-left: ${theme.spacing[6]};
  `
);

export const StyledSkeletonLoaderButton = styled(SkeletonLoaderButton)(
  ({ theme }) => css`
    margin-left: ${theme.spacing[6]};
  `
);

export const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - ${pxToRem(HEADER_HEIGHT)});
`;
